export default __webpack_public_path__ + "warning-sign-on-a-triangular-background.png";